import React, { useState } from 'react';
import '../styles/subscribe.css'; // Import the CSS file


const SubscriptionForm = () => {
const [email, setEmail] = useState('');
const [isSubscribed, setIsSubscribed] = useState(false);
const [isLoading, setIsLoading] = useState(false);
const [error, setError] = useState('');

const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
};

const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!email) {
    setError('Email is required');
    return;
    }
    
    if (!validateEmail(email)) {
    setError('Please enter a valid email');
    return;
    }

    setError('');
    setIsLoading(true);
    
    // Simulate API call
    setTimeout(() => {
    setIsSubscribed(true);
    setIsLoading(false);
    setEmail('');
    }, 1500);
};

return (
    <div className="subscription-container">
    {isSubscribed ? (
        <div className="success-message">
        <h3>Thank you for subscribing!</h3>
        <p>You'll receive our updates soon.</p>
        </div>
    ) : (
        <form onSubmit={handleSubmit} className="subscription-form">
        <h3>Subscribe to DebateMindAI</h3>
        <p>Get the latest updates delivered to your inbox</p>
        
        <div className="input-group">
            <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            className={`email-input ${error ? 'error' : ''}`}
            disabled={isLoading}
            />
            {error && <span className="error-message">{error}</span>}
        </div>
    
        <button
            type="submit"
            className={`subscribe-btn ${isLoading ? 'loading' : ''}`}
            disabled={isLoading}
        >
            {isLoading ? (
            <span className="spinner"></span>
            ) : (
            'Subscribe'
            )}
        </button>
        </form>
    )}
    </div>
);
};

export default SubscriptionForm;